import globalWin from '@/utils/globalWin';
import { IMSDK } from '@/imsdk/index';
import { GET_CONSULT_FORM_DETAIL, SUBMIT_CONSULT_FORM } from '@/utils/api';
import { throttle } from '@tencent/qd-lib';

const imsdk = IMSDK.create();
export default {
  inject: ['to', 'wpaDetail', 'globalData'],
  data() {
    return {
      // 是否显示表单
      openPop: false,
      // 表单数据
      data: {
        content: [],
      },
    };
  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
  },
  methods: {
    /**
     * 展开表单，带参数初始化表单内容
     * @param {*} params
     */
    show(params) {
      setTimeout(() => {
        this.openPop = true;
      }, 400);
      const { formId = '', grayMsgSeq = '', uk = '' } = params;
      // 表单ID
      this.formId = formId;
      // 跟表单关联的那条灰条消息的Seq
      this.connectionGrayMsgSeq = grayMsgSeq;
      // 后端透传的特征值
      this.uk = uk;
      // 获取表单内容信息
      this.getInformationData();
    },
    /**
     * 关闭弹窗
     */
    close() {
      globalWin.switchConsultForm(false);
    },
    /**
     * 获取表单内容信息
     */
    getInformationData() {
      const params = {
        kfext: this?.globalData?.reception?.extuin, // B工号
        wpaId: this?.wpaDetail?.wpaId, // 根据wpaId获取询前表单配置，询前必填
        isPre: false, // 是否询前
        uk: this.uk,
        channelID: imsdk?.config?.channelType, // 通路id
        custID: this?.to?.user_id, // C社交账号
        formID: this?.formId,
      };
      this.$ajax
        .post(GET_CONSULT_FORM_DETAIL, params)
        .then((res) => {
          const { code, data } = res.data;
          if (+code === 0) {
            this.data = this.preHandleFormData(data);
          } else {
            this.$Toast('获取表单信息失败');
            setTimeout(() => {
              this.hide();
            }, 500);
          }
        })
        .catch((error) => {
          this.$Toast('获取表单信息失败');
          console.error('获取表单_catch', error);
          setTimeout(() => {
            this.hide();
          }, 500);
        });
    },

    /**
     * 处理提交逻辑
     */
    handleSubmit: throttle(function () {
      // 校验表单内容
      if (!this.checkSubmitContent()) {
        return;
      }
      const submitData = this.preHandleSubmitData();
      const params = {
        channelID: imsdk?.config?.channelType, // 通路id
        custID: this?.to?.user_id, // C社交账号
        kfext: this?.globalData?.reception?.extuin, // B工号
        formID: this?.data?.id, // 表单id
        content: submitData || this.data.content,
        uk: this.uk,
        wpaId: this?.wpaDetail?.wpaId, // 根据wpaId获取询前表单配置，询前必填
      };
      this.$ajax.post(SUBMIT_CONSULT_FORM, params)
        .then((res) => {
          const { code, msg } = res.data;
          if (+code === 0) {
            const textContent = this.getFormTextMsgContent();
            globalWin.sendTextMessage(textContent);
            // 处理下点击的那条灰条消息，隐藏填写按钮
            globalWin.splitGrayMsgContent(this.connectionGrayMsgSeq);
            this.hide();
          } else {
            this.$Toast(msg || '表单信息提交失败');
          }
        })
        .catch((e) => {
          this.$Toast('表单信息提交失败');
          console.error('表单信息提交_catch', e);
        });
    }, 500),

    /**
     * 提交之前预处理，为了不影响本地渲染，拷贝一下对象
     * @returns
     */
    preHandleSubmitData() {
      const submitData = this.data.content.map((element) => {
        try {
          const item = JSON.parse(JSON.stringify(element));
          if (element.type === 8) {
            // 多选类型PC端是数组，h5是string，要先转成数组，然后再stringify提交
            const choosedArray = this.isMobile && item.value ? item.value.split(',') : item.value;
            item.value = choosedArray.length ? JSON.stringify(choosedArray) : '';
            return item;
          }
          return element;
        } catch {
          return element;
        }
      });
      return submitData;
    },
    // 跳过
    handleSkip() {
      this.close();
    },
    // 隐藏弹窗
    hide() {
      this.openPop = false;
    },
    /**
     * 组装上屏文本消息内容
     * @returns
     */
    getFormTextMsgContent() {
      const formStr = this.data.content.reduce((text, item) => {
        let shownText = item.encrypted && item.value ? '****' : item.value;
        // 多选加缩进和标识符
        if (item.type === 8) {
          const choosedArray = this.isMobile && item.value ? item.value.split(',') : item.value;
          shownText = Array.isArray(choosedArray) ? choosedArray.reduce((str, opt) => `${str}\n   ● ${opt}`, '') : '';
        }
        const itemStr = `- ${item.name}: ${shownText}\n`;
        return text + itemStr;
      }, '');
      return `我已提交表单“${this.data.title}”\n${formStr}`;
    },
    /**
     * 校验表单内容
     * @param {*} item
     * @param {*} index
     */
    checkFormItem(item, index) {
      if (item.required && !item.value) {
        this.$set(this.data.content[index], 'error', `${item.name}不能为空`);
        return false;
      }
      this.$set(this.data.content[index], 'error', '');
      return true;
    },
    checkSubmitContent() {
      const content = this?.data?.content || [];
      const { length } = content;
      for (let i = 0; i < length;i++) {
        if (!this.checkFormItem(content[i], i)) {
          return false;
        }
      }
      return true;
    },
    focus(item, index) {
      this.$set(this.data.content[index], 'isFocus', true);
    },
    blur(item, index) {
      setTimeout(() => {
        this.$set(this.data.content[index], 'isFocus', false);
      }, 500);

      this.checkFormItem(item, index);
    },
    // 清除文本内容
    clearText(item, index) {
      this.data.content[index].value = '';
    },
    // 渲染之前预处理
    preHandleFormData(data) {
      data.content.forEach((item) => {
        try {
          if (item.type === 8) {
            const choosedArray = item.value ? JSON.parse(item.value) : [];
            // PC端 原生多选接收数组，H5 vant需要字符串，渲染使用
            item.value = this.isMobile ? choosedArray.join(',') : choosedArray;
          }
        } catch (e) {
          console.log('preHandleFormData_catch', e);
        }
      });
      return data;
    },
  },
};
